// Wholesale Enquiry form controller.
//
// Posts the form to wp-admin/admin-ajax.php (action:
// sentiments_wholesale_enquiry). The server-side handler in
// functions.php validates + wp_mail()s the enquiry. AJAX endpoint URL
// and nonce are localized into window.sentimentsWholesale (alongside
// sentimentsNewsletter).
//
// UX:
//   - Submit click → button enters loading state (data-state="loading")
//   - On success: status message appears in green, form resets
//   - On error:   status message appears in red, button restored

export function initWholesaleForm() {
	const form = document.querySelector('[data-wholesale-form]');
	if (!form) return;

	const submit = form.querySelector('.sentiments-wholesale-page__submit');
	const status = form.querySelector('.sentiments-wholesale-page__status');

	const setStatus = (state, message) => {
		if (!status) return;
		status.dataset.state = state;
		status.textContent = message;
	};

	const setSubmitting = (isSubmitting) => {
		if (!submit) return;
		if (isSubmitting) {
			submit.dataset.state = 'loading';
			submit.setAttribute('aria-busy', 'true');
		} else {
			delete submit.dataset.state;
			submit.removeAttribute('aria-busy');
		}
	};

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		setStatus('', '');

		// Browser-native validity check first — surfaces required-field
		// hints in the user's locale.
		if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
			return;
		}

		const config = window.sentimentsWholesale;
		if (!config || !config.ajax) {
			setStatus('error', 'Form is offline — please email info@sentimentsindia.com instead.');
			return;
		}

		const data = new FormData(form);
		data.append('action', 'sentiments_wholesale_enquiry');
		data.append('nonce', config.nonce);

		setSubmitting(true);

		try {
			const response = await fetch(config.ajax, {
				method: 'POST',
				body: data,
				credentials: 'same-origin',
			});

			let payload;
			try { payload = await response.json(); } catch { payload = {}; }

			if (response.ok && payload && payload.ok) {
				setStatus(
					'success',
					payload.message || 'Thank you — we will be in touch shortly.'
				);
				form.reset();
			} else {
				setStatus(
					'error',
					(payload && payload.message) || 'Something went wrong. Please try again.'
				);
			}
		} catch (err) {
			setStatus('error', 'Could not reach our server. Please try again in a moment.');
		} finally {
			setSubmitting(false);
		}
	});
}
